import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import {
  Grid,
  Button,
  Select,
  Divider,
  TextField,
  InputLabel,
  Typography,
  FormControl,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormHelperText,
  MenuItem,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import dayjs from "dayjs";
import { Autocomplete } from "@material-ui/lab";
import { CheckBoxOutlineBlank, CheckBox } from "@material-ui/icons";
import { DropzoneArea } from "material-ui-dropzone";
import { createStyles, makeStyles } from "@material-ui/core/styles";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";

import MultiFileManager from "../../File/MultiFileManager/MultiFileManager";
import KPTimePicker from "../../../components/KPTimePicker";
import EmploymentContractTable from "../../../components/EmployContractModal/EmploymentContractTable";
import EmploymentContractDetailTable from "../../../components/EmployContractModal/EmploymentContractDetailTable";

import { insertProject, updateProject, getProfileInfoByProfileId } from "../../../reducer/project/action";
import { uploadMultiFile } from "../../../reducer/file/action";
import { getAllProfile, statisticUnaccepted } from "../../../reducer/profile/action";
import { getAllEmploymentContractByProfileId } from "../../../reducer/employmentContract/action";
import moment from "moment";
import { external } from "jszip";
import { getAllPurpose } from "reducer/scientificResearch/action";
import { getTimeResearchInformation } from "reducer/timeResearchInformation/action";

function ProjectInsertModal(props) {
  const { inserting, setInserting } = props;

  const currentYear = new Date().getFullYear();

  const [detail, setDetail] = useState(null);
  const [values, setValues] = useState({
    startAt: `01/01/${currentYear}`,
    finishAt: `01/01/${currentYear}`,
    dashboardYear: currentYear,
    purposeId: 5,
    type: "basic",
    level: "none",
    levelDetail: "none",
    status: "processing",
  });
  const [profileList, setProfileList] = useState([]);
  const [studentList, setStudentList] = useState([]);
  const [timeResearchYear, setTimeResearchYear] = useState(0);
  const [timeResearchDetailList, setTimeResearchDetailList] = useState([]);
  const [newFiles, setNewFiles] = useState([]);
  const [helperText, setHelperText] = useState(false);
  const [studentHelperText, setStudentHelperText] = useState(false);

  // useEffect(() => {
  //   if (
  //     props.timeResearchInformationList.slice(0, 1)?.shift()?.year !== timeResearchYear &&
  //     !props.isFetchingTimeResearchInformation
  //   ) {
  //     getTimeResearchInformation(0, timeResearchYear);
  //   }
  // }, []);

  // Tự gán bản thân vào danh sách tác giả
  React.useEffect(() => {
    if (props.inserting) {
      // Reset newFiles khi mở modal mới
      setNewFiles([]);
    }
    if (props.profile?.id && profileList.length === 0) {
      setProfileList([
        {
          profileId: props.profile.id,
          roleInProject: "main",
          statusInProject: "K",
          isInternal: true,
          externalName: "",
        },
      ]);
    }
  }, [props.inserting, props.profile?.id]);

  // Chọn thành viên để lấy đề tài thì load lại đề tài của ông ấy
  React.useEffect(() => {
    if (values?.profileIdToSelectId) props.getProfileInfoByProfileId(values?.profileIdToSelectId);
  }, [values?.profileIdToSelectId]);

  // Tự động tính finishAt dựa trên startAt và duration
  React.useEffect(() => {
    if (values?.startAt && values?.duration && values?.startAt !== "dd/mm/yyyy") {
      const dateForm = values.startAt?.replaceAll("/", "");
      const date = dateForm?.substr(0, 2);
      const month = dateForm?.substr(2, 2);
      const year = dateForm?.substr(-4);
      const startDate = dayjs(`${month}/${date}/${year}`);
      const endDate = startDate.add(values.duration, "month");
      const formattedEndDate = endDate.format("DD/MM/YYYY");
      if (values.finishAt !== formattedEndDate) {
        setValues((prev) => ({ ...prev, finishAt: formattedEndDate }));
      }
    }
  }, [values?.startAt, values?.duration, values?.finishAt]);

  // Tự động cập nhật dashboardYear từ năm của startAt
  React.useEffect(() => {
    if (values?.startAt && values?.startAt !== "dd/mm/yyyy") {
      const dateForm = values.startAt?.replaceAll("/", "");
      const year = dateForm?.substr(-4);
      const dashboardYear = parseInt(year);
      if (values?.dashboardYear !== dashboardYear) {
        setValues((prev) => ({ ...prev, dashboardYear }));
      }
    }
  }, [values?.startAt, values?.dashboardYear]);

  const dateFormat = (value) => {
    const dateForm = value?.replaceAll("/", "");
    const date = dateForm?.substr(0, 2);
    const month = dateForm?.substr(2, 2);
    const year = dateForm?.substr(-4);
    return value ? dayjs(`${month}/${date}/${year}`).format("YYYY-MM-DDTHH:mm:ss") + "Z" : null;
  };

  const valueFormat = (value) => {
    const temp = value.replace(/\D/g, "").replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ".");
    return temp;
  };

  const handleChangeForm = (name, value) => {
    if (name === "timeResearchDetailCode") {
      setValues({
        ...values,
        [name]: value === "null" ? null : value,
      });
    } else setValues({ ...values, [name]: value });
  };

  const handleChangeFormMultiValue = (listKeyValue) => {
    let tempValues = { ...values };
    listKeyValue.forEach((item) => {
      if (item.name === "timeResearchDetailCode") {
        tempValues = {
          ...tempValues,
          [item.name]: item.value === "null" ? null : item.value,
        };
      } else {
        tempValues = { ...tempValues, [item.name]: item.value };
      }
    });
    setValues(tempValues);
  };

  const handleChangeProfileList = (index, name, value) => {
    const temp = profileList;
    const tempElm = profileList[index];
    temp.splice(index, 1, { ...tempElm, [name]: value });
    setProfileList([...temp]);
  };

  const handleInsert = () => {
    const temp = profileList;
    temp.push({
      profileId: null,
      roleInProject: "member",
      statusInProject: "K",
      isInternal: true,
      externalName: "",
    });
    setProfileList([...temp]);
  };

  const handleRemove = (index) => {
    const temp = profileList;
    temp.splice(index, 1);
    setProfileList([...temp]);
  };

  const handleChangeStudentList = (index, name, value) => {
    const temp = studentList;
    const tempElm = studentList[index];
    temp.splice(index, 1, { ...tempElm, [name]: value });
    setStudentList([...temp]);
  };

  const handleInsertStudent = () => {
    const temp = studentList;
    temp.push({
      studentName: "",
      studentCode: "",
      roleInProject: "member",
      class: "",
      major: "",
      cohort: "",
      identity: "",
      isStudent: true,
    });
    setStudentList([...temp]);
  };

  const handleRemoveStudent = (index) => {
    const temp = studentList;
    temp.splice(index, 1);
    setStudentList([...temp]);
  };

  const handleSubmit = (e) => {
    // check title, code, numOfMember, duration
    if (
      !values?.title ||
      !values?.code ||
      !values?.numOfMember ||
      values?.numOfMember <= 0 ||
      !values?.duration ||
      values?.duration <= 0 ||
      values?.level === "none" ||
      values?.levelDetail === "none"
    ) {
      setHelperText(true);
      return;
    }

    // Validate student list if any students were added
    const hasInvalidStudent = studentList.some(
      (student) => !student.studentName || !student.studentCode || !student.roleInProject,
    );
    if (hasInvalidStudent) {
      setStudentHelperText(true);
      return;
    }

    // e.preventDefault();
    setInserting(false);
    const d = new Date();

    // Merge profileList and studentList into researchProjectProfile
    const combinedList = [
      ...profileList,
      ...studentList.map((student) => ({
        ...student,
        profileId: null,
        externalName: student.studentName,
        isInternal: false,
        statusInProject: "K",
        isStudent: true,
      })),
    ];

    // console.log("values to submit", {
    //   ...values,
    //   dashboardYear: new Date(dateFormat(values?.startAt || moment().format("YYYY-MM-DD"))).getFullYear(),
    //   researchProjectProfile: combinedList,
    //   startAt: dateFormat(values?.startAt || moment().format("YYYY-MM-DD")),
    //   finishAt: dateFormat(values?.finishAt || moment().format("YYYY-MM-DD")),
    //   profileId: parseInt(values?.profileIdToSelectId),
    //   patentId: values?.typeToSelectId === "patent" ? values?.selectId : 0,
    //   productContractId: values?.typeToSelectId === "productContract" ? values?.selectId : 0,
    //   scientificResearchId: values?.typeToSelectId === "scientificResearch" ? values?.selectId : 0,
    //   solutionId: values?.typeToSelectId === "solution" ? values?.selectId : 0,
    // });

    props
      .insertProject(props.profile?.id, {
        ...values,
        duration: values?.duration?.toString(),
        dashboardYear: new Date(dateFormat(values?.startAt || moment().format("YYYY-MM-DD"))).getFullYear(),
        researchProjectProfile: combinedList,
        startAt: dateFormat(values?.startAt || moment().format("YYYY-MM-DD")),
        finishAt: dateFormat(values?.finishAt || moment().format("YYYY-MM-DD")),
        profileId: parseInt(values?.profileIdToSelectId),
        patentId: values?.typeToSelectId === "patent" ? values?.selectId : 0,
        productContractId: values?.typeToSelectId === "productContract" ? values?.selectId : 0,
        scientificResearchId: values?.typeToSelectId === "scientificResearch" ? values?.selectId : 0,
        solutionId: values?.typeToSelectId === "solution" ? values?.selectId : 0,
      })
      .then((response) => {
        if (response.success && newFiles.length !== 0) {
          props
            .uploadMultiFile(response.data.id, newFiles, "researchProject")
            .then((responseUpload) => {
              if (responseUpload.success) {
                props.updateProject(response.data.id, {
                  ...response.data,
                  fileUrl: responseUpload.data.join("||"),
                });
              }
            })
            .catch();
        }
        if (response.success) {
          props.statisticUnaccepted({
            departmentId: 0,
            profileId: props.profile?.id,
          });
          if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
        }
      });
    setValues(null);
    setProfileList([]);
    setStudentList([]);
    setNewFiles([]);
  };

  const contractList = [];
  props?.employmentContractListById.forEach((e) => contractList.push(e.contract));

  const profileListFromProps = [{ id: -1, name: "" }];
  props.profileList.forEach((e) => profileListFromProps.push(e));

  const selectList = [];
  if (values?.typeToSelectId) {
    props[values?.typeToSelectId + "s"].forEach((e) => selectList.push(e[values?.typeToSelectId]));
  }

  // Filter timeResearchDetailList based on level without year filtering
  useEffect(() => {
    if (props.timeResearchInformationList?.length > 0) {
      let miniType = "";
      if (values?.level === "de_tai_ngoai_truong") miniType = "-de_tai_ngoai_truong";
      if (values?.level === "de_tai_cap_truong") miniType = "-de_tai_cap_truong";
      if (values?.level === "de_tai_cap_bo_va_tuong_duong") miniType = "-de_tai_cap_bo_va_tuong_duong";

      // Get all timeResearchDetail from all years and filter by type
      let allDetails = [];
      props.timeResearchInformationList.forEach((yearData) => {
        if (yearData.timeResearchDetail) {
          allDetails = [...allDetails, ...yearData.timeResearchDetail];
        }
      });

      let list = allDetails.filter((e) => !e.allowedUpdateNum && e.type?.includes("researchProject" + miniType));
      setTimeResearchDetailList(list || []);

      setValues({
        ...values,
        levelDetail: "none",
        timeResearchDetailCode: null,
      });
    }
  }, [props.timeResearchInformationList, values?.level]);
  // console.log("timeResearchDetailList", timeResearchDetailList, props.timeResearchInformationList);

  // const yearList = [];
  // props.timeResearchInformationList
  //   .sort((a, b) => b.year - a.year)
  //   .forEach((e) => {
  //     yearList.push(e.year);
  //   });

  // Render Loại công trình options from timeResearchDetailList
  const renderLevelDetailOptions = useMemo(() => {
    if (values?.level && values?.level !== "none" && timeResearchDetailList.length > 0) {
      return (
        <>
          <option value="none">Chọn giá trị</option>
          {timeResearchDetailList.map((item) => (
            <option key={item.code} value={item.code}>
              {item.description}
            </option>
          ))}
        </>
      );
    } else {
      return <option value="none">Chọn cấp đề tài trước</option>;
    }
  }, [values?.level, timeResearchDetailList]);

  const handleClose = () => {
    setInserting(false);
    setValues({
      startAt: `01/01/${currentYear}`,
      finishAt: `01/01/${currentYear}`,
      purposeId: 5,
      type: "basic",
      level: "none",
      levelDetail: "none",
      status: "processing",
    });
    setProfileList([]);
    setStudentList([]);
    setNewFiles([]);
  };
  // console.log("values", values);

  return (
    <Dialog
      fullWidth
      keepMounted
      maxWidth={false}
      open={inserting}
      onClose={() => handleClose()}
      disableBackdropClick
      PaperProps={{
        style: {
          width: "calc(100vw - 240px)",
          height: "100vh",
          maxWidth: "calc(100vw - 240px)",
          maxHeight: "100vh",
          margin: "0 0 0 240px",
        },
      }}
    >
      <DialogTitle
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "16px 24px",
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        <Typography variant="h5" style={{ fontWeight: 600, marginRight: 24 }}>
          Thêm đề tài
        </Typography>
        <div style={{ display: "flex", gap: "12px", marginTop: 8 }}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => handleClose()}
            style={{
              padding: "8px 24px",
              fontSize: "15px",
              fontWeight: 500,
              borderWidth: 2,
            }}
          >
            Huỷ
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleSubmit()}
            // disabled={!values?.timeResearchDetailCode}
            style={{
              padding: "8px 24px",
              fontSize: "15px",
              fontWeight: 600,
              boxShadow: "0 2px 8px rgba(63, 81, 181, 0.3)",
            }}
          >
            Xác nhận
          </Button>
        </div>
      </DialogTitle>
      <DialogContent style={{ flex: 1, overflow: "hidden", display: "flex", padding: 0 }}>
        <div
          style={{
            width: "60%",
            padding: "16px 24px",
            overflowY: "auto",
            borderRight: "1px solid #e0e0e0",
          }}
        >
          <Grid container justifyContent="flex-start" spacing={2} style={{ marginBottom: 10 }}>
            <Grid item xs={9}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                label="Tên đề tài"
                required
                value={values?.title || ""}
                error={helperText && !values?.title}
                helperText={helperText && !values?.title ? "Vui lòng nhập tên đề tài" : ""}
                onChange={(event) => handleChangeForm("title", event.target.value)}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                size="small"
                type="number"
                variant="outlined"
                label="Số lượng thành viên"
                required
                value={values?.numOfMember || ""}
                error={helperText && !values?.numOfMember}
                helperText={helperText && !values?.numOfMember ? "Vui lòng nhập số lượng thành viên" : ""}
                onChange={(event) => handleChangeForm("numOfMember", parseInt(event.target.value))}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                label="Mã đề tài"
                required
                value={values?.code || ""}
                error={helperText && !values?.code}
                helperText={helperText && !values?.code ? "Vui lòng nhập mã số" : ""}
                onChange={(event) => handleChangeForm("code", event.target.value)}
              />
            </Grid>
            <Grid item xs={3}>
              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel id="type-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                  Loại hình nghiên cứu
                </InputLabel>
                <Select
                  native
                  fullWidth
                  labelId="type-label"
                  value={values?.type || ""}
                  onChange={(event) => handleChangeForm("type", event.target.value)}
                >
                  <option value="basic">Nghiên cứu cơ bản</option>
                  <option value="application">Nghiên cứu ứng dụng</option>
                  <option value="deploy">Nghiên cứu triển khai</option>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel id="level-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                  Cấp đề tài
                </InputLabel>
                <Select
                  native
                  fullWidth
                  required
                  displayEmpty
                  labelId="level-label"
                  value={values?.level || ""}
                  error={helperText && values?.level === "none"}
                  helperText={helperText && values?.level === "none" ? "Vui lòng nhập chọn cấp đề tài" : ""}
                  onChange={(event) => {
                    // handleChangeForm("level", event.target.value);
                    handleChangeFormMultiValue([
                      { name: "levelDetail", value: "none" },
                      { name: "level", value: event.target.value },
                      { name: "timeResearchDetailCode", value: null },
                    ]);
                  }}
                >
                  {/* <option value={null} /> */}
                  <option value="none">Chọn giá trị</option>
                  <option value="de_tai_ngoai_truong">Đề tài các cấp không do Nhà trường quản lý ra quyết định</option>
                  <option value="de_tai_cap_truong">Đề tài cấp Trường và tương đương</option>
                  <option value="de_tai_cap_bo_va_tuong_duong">
                    Đề tài/dự án từ cấp Bộ và tương đương trở lên giao cho Trường ra quyết định giao nhiệm vụ chủ trì
                  </option>
                  {/* <option value="school">Cơ sở</option>
                  <option value="ministry">Bộ</option>
                  <option value="keyMinistry">Trọng điểm của bộ</option>
                  <option value="nafosted">Nafosted</option>
                  <option value="domestic">Nhà nước</option>
                  <option value="international">Quốc gia</option> */}
                  {/* <option value={"khac"}>Khác</option> */}
                </Select>
              </FormControl>
            </Grid>
            {values?.level && values?.level != "none" && (
              <Grid item xs={12}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel id="level-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                    Loại công trình
                  </InputLabel>
                  <Select
                    native
                    fullWidth
                    required
                    labelId="level-label"
                    value={values?.levelDetail || ""}
                    error={helperText && values?.levelDetail === "none"}
                    helperText={
                      helperText && values?.levelDetail === "none" ? "Vui lòng nhập chọn loại công trình" : ""
                    }
                    onChange={(event) => {
                      const selectedCode = event.target.value;
                      // Set both levelDetail and timeResearchDetailCode to the selected code
                      handleChangeFormMultiValue([
                        { name: "levelDetail", value: selectedCode },
                        { name: "timeResearchDetailCode", value: selectedCode },
                      ]);
                    }}
                  >
                    {renderLevelDetailOptions}
                  </Select>
                </FormControl>
              </Grid>
            )}
            <Grid item xs={12}>
              <TextField
                rows={2}
                fullWidth
                multiline
                size="small"
                variant="outlined"
                label="Sản phẩm đăng ký"
                value={values?.productName || ""}
                onChange={(event) => handleChangeForm("productName", event.target.value)}
              />
            </Grid>
            <Grid item xs={4}>
              <KPTimePicker
                fullWidth
                label="Thời gian bắt đầu"
                required
                value={values?.startAt || `01/01/${currentYear}`}
                setValue={(newValue) => handleChangeForm("startAt", newValue)}
              />
              {values?.startAt === "dd/mm/yyyy" && (
                <FormHelperText error>Vui lòng điền thời gian bắt đầu!</FormHelperText>
              )}
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                size="small"
                type="number"
                variant="outlined"
                label="Thời gian thực hiện (tháng)"
                required
                step={1}
                min={1}
                max={36}
                value={values?.duration || ""}
                error={helperText && (!values?.duration || values?.duration <= 0)}
                helperText={
                  helperText && (!values?.duration || values?.duration <= 0) ? "Vui lòng nhập thời gian thực hiện" : ""
                }
                onChange={(event) => {
                  // check min max
                  let val = event.target.value;
                  if (val < 1) val = 1;
                  if (val > 36) val = 36;
                  handleChangeForm("duration", val);
                }}
                inputProps={{ min: 1 }}
              />
            </Grid>
            <Grid item xs={4}>
              <KPTimePicker
                fullWidth
                disabled
                label="Thời gian kết thúc"
                value={values?.finishAt || `01/01/${currentYear}`}
                setValue={(newValue) => handleChangeForm("finishAt", newValue)}
              />
              <FormHelperText>Tự động tính từ thời gian bắt đầu + tháng</FormHelperText>
            </Grid>
            <Grid item xs={12}>
              <TextField
                select
                fullWidth
                size="small"
                variant="outlined"
                label="Đơn vị chủ trì"
                value={values?.host || ""}
                onChange={(event) => handleChangeForm("host", event.target.value)}
              >
                <MenuItem value={"neu"}>Trường Đại học VinUni</MenuItem>
                <MenuItem value={"other"}>Trường đại học khác</MenuItem>
              </TextField>
            </Grid>
            {/* <Grid item xs={6}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                label="Cơ quan tài trợ"
                value={values?.sponsor || ""}
                onChange={(event) => handleChangeForm("sponsor", event.target.value)}
              />
            </Grid> */}
            <Grid item xs={4}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                label="Kinh phí thực hiện"
                value={values?.value || ""}
                InputProps={{
                  endAdornment: <InputAdornment position="end">VND</InputAdornment>,
                }}
                onChange={(event) => handleChangeForm("value", valueFormat(event.target.value))}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                label="Kinh phí khác"
                value={values?.kinhPhiKhac || ""}
                InputProps={{
                  endAdornment: <InputAdornment position="end">VND</InputAdornment>,
                }}
                onChange={(event) => handleChangeForm("kinhPhiKhac", valueFormat(event.target.value))}
              />
            </Grid>
            <Grid item xs={4}>
              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel id="status-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                  Tình trạng
                </InputLabel>
                <Select
                  native
                  fullWidth
                  labelId="status-label"
                  value={values?.status || ""}
                  onChange={(event) => handleChangeForm("status", event.target.value)}
                >
                  {/* <option value={null} /> */}
                  <option value="processing">Đang tiến hành</option>
                  <option value="accepted">Đã nghiệm thu</option>
                  <option value="extend">Gia hạn</option>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <KPTimePicker
                fullWidth
                label="Thời gian nghiệm thu"
                value={values?.ngayNghiemThu || `01/01/${currentYear}`}
                setValue={(newValue) => handleChangeForm("ngayNghiemThu", newValue)}
              />
              {/* {values?.ngayNghiemThu === "dd/mm/yyyy" && (
                <FormHelperText error>Vui lòng điền thời gian nghiệm thu!</FormHelperText>
              )} */}
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel id="purpose-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                  Mục đích
                </InputLabel>
                <Select
                  native
                  fullWidth
                  labelId="purpose-label"
                  value={values?.purposeId === 0 ? null : (values?.purposeId ?? "none")}
                  onChange={(event) => handleChangeForm("purposeId", parseInt(event.target.value))}
                >
                  {props.purposes.map((e) => {
                    // if (e.name === "timeResearch" || e.name === "other")
                    return (
                      <option key={e.id} value={e.id}>
                        {e.description}
                      </option>
                    );
                    // if (e.name === "oldPaper")
                    //   return (
                    //     <option key={e.id} value={e.id}>
                    //       Đề tài không phải Phenikaa chủ trì
                    //     </option>
                    //   );
                    return <option hidden />;
                  })}
                </Select>
              </FormControl>
            </Grid>

            {/* <Grid item xs={3}>
              <TextField
                fullWidth
                select
                size='small'
                label='Mục đích'
                variant='outlined'
                value={values?.purposeId ?? 'none'}
                SelectProps={{ native: true }}
                onChange={(event) => handleChangeForm('purposeId', parseInt(event.target.value, 10))}
              >
                {props.purposes.map(e => {
                    if (e.name === 'timeResearch')
                      return <option key={e.id} value={e.id}>{e.description}</option>
                    if (e.name === 'oldPaper')
                      return <option key={e.id} value={e.id}>Đề tài không phải Phenikaa chủ trì</option>
                    return <option hidden />
                  })
                }
              </TextField>
            </Grid> */}

            {/* Commented out: Năm học */}
            {/* <Grid item xs={3}>
              <TextField
                fullWidth
                size="small"
                disabled
                label="Năm học"
                variant="outlined"
                value={values?.dashboardYear ? `${values.dashboardYear} - ${values.dashboardYear + 1}` : ""}
                helperText="Tự động từ ngày bắt đầu"
              />
            </Grid> */}
            {/* Commented out: Năm học tính giờ nghiên cứu and Nhiệm vụ tính giờ nghiên cứu */}
            {/* {values?.purposeId === 5 && (
              <>
                <Grid item xs={3} style={{ display: "none" }}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    value={timeResearchYear}
                    SelectProps={{ native: true }}
                    label="Năm học tính giờ nghiên cứu"
                    variant="outlined"
                    onChange={(event) => {
                      setTimeResearchYear(parseInt(event.target.value));
                      handleChangeForm("timeResearchDetailCode", null);
                    }}
                  >
                    {yearList.map((e) => (
                      <option key={`${e} - ${e + 1}`} value={parseInt(e)}>
                        {e} - {e + 1}
                      </option>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Nhiệm vụ tính giờ nghiên cứu"
                    variant="outlined"
                    value={values?.timeResearchDetailCode || null}
                    onChange={(event) => handleChangeForm("timeResearchDetailCode", event.target.value)}
                    InputLabelProps={{
                      shrink: !(
                        values?.timeResearchDetailCode === undefined || values?.timeResearchDetailCode === null
                      ),
                    }}
                    // [VinUni] bỏ bắt buộc chọn loại công trình (không còn tính giờ)
                    error={false}
                  >
                    {timeResearchDetailList.length > 0 ? (
                      timeResearchDetailList?.map((e) => (
                        <MenuItem key={e.code} value={e.code}>
                          <div style={{ display: "flex", flexDirection: "column", maxWidth: 800 }}>
                            <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{e.description}</div>
                            <span style={{ color: "rgba(0, 0, 0, 0.54)" }}>{`${e.value}(h)`}</span>
                          </div>
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem value={null}>Chưa có dữ liệu</MenuItem>
                    )}
                  </TextField>
                </Grid>
              </>
            )} */}

            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                label="Ghi chú"
                variant="outlined"
                value={values?.note || ""}
                multiline
                rows={3}
                onChange={(event) => handleChangeForm("note", event.target.value)}
              />
            </Grid>

            <Grid item xs={5} style={{ margin: "auto" }}>
              <Divider />{" "}
            </Grid>
            <Grid item xs={2}>
              <Typography style={{ textAlign: "center", color: "rgba(0, 0, 0, 0.30)" }}>Thành viên</Typography>
            </Grid>
            <Grid item xs={5} style={{ margin: "auto" }}>
              <Divider />{" "}
            </Grid>

            <Grid item xs={12}>
              {profileList.map((e, index) => (
                <Grid key={`list-${index}`} container spacing={2}>
                  <Grid item xs={1}>
                    {/* Check box default is checked với text "nội bộ" */}
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={e.isInternal !== false}
                          onChange={(event) => handleChangeProfileList(index, "isInternal", event.target.checked)}
                          color="primary"
                        />
                      }
                      label="Nội bộ"
                    />
                  </Grid>
                  {e.isInternal && (
                    <Grid item xs={values?.purposeId !== 1 && values?.purposeId !== 99999999 ? 5 : 2}>
                      <Autocomplete
                        disableClearable
                        options={props.profileList}
                        getOptionLabel={(option) => option.name}
                        value={
                          profileListFromProps?.find((profile) => profile.id === e.profileId) || profileListFromProps[0]
                        }
                        onChange={(event, profile) => {
                          if (profileList[index]?.profileId === values?.profileIdForKpi)
                            handleChangeForm("profileIdForKpi", null);
                          handleChangeProfileList(index, "profileId", parseInt(profile?.id));
                        }}
                        renderInput={(params) => (
                          <TextField {...params} size="small" label="Thành viên" variant="outlined" />
                        )}
                      />
                    </Grid>
                  )}
                  {!e.isInternal && (
                    <Grid item xs={values?.purposeId !== 1 && values?.purposeId !== 99999999 ? 5 : 2}>
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        label="Tên thành viên"
                        value={e?.externalName || ""}
                        onChange={(event) => handleChangeProfileList(index, "externalName", event.target.value)}
                      />
                    </Grid>
                  )}
                  {e.isInternal && (
                    <>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          size="small"
                          disabled
                          variant="outlined"
                          label="Mã viên chức"
                          value={profileListFromProps?.find((profile) => profile.id === e.profileId)?.code || ""}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          size="small"
                          disabled
                          variant="outlined"
                          label="Đơn vị"
                          value={
                            profileListFromProps?.find((profile) => profile.id === e.profileId)?.departmentProfile?.[0]
                              ?.department?.name || ""
                          }
                        />
                      </Grid>
                    </>
                  )}

                  <Grid item xs={values?.purposeId !== 1 && values?.purposeId !== 99999999 ? 3 : 1}>
                    <FormControl fullWidth variant="outlined" size="small">
                      <InputLabel id="roleInProject-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                        Vai trò
                      </InputLabel>
                      <Select
                        native
                        fullWidth
                        labelId="roleInProject-label"
                        value={e?.roleInProject || "main"}
                        onChange={(event) => handleChangeProfileList(index, "roleInProject", event.target.value)}
                      >
                        <option value="main">Chủ nhiệm</option>
                        <option value="secretary">Thư kí khoa học</option>
                        <option value="mainMember">Thành viên chính</option>
                        <option value="member">Thành viên</option>
                      </Select>
                    </FormControl>
                  </Grid>
                  {/* {values?.purposeId === 1 && (
                    <Grid item xs={2}>
                      <FormControl required fullWidth error={!values?.profileIdForKpi}>
                        <Button
                          fullWidth
                          color="primary"
                          variant="outlined"
                          style={{ height: 40 }}
                          disabled={e.profileId === null}
                          startIcon={
                            typeof values?.profileIdForKpi === "number" && values?.profileIdForKpi === e.profileId ? (
                              <CheckBox />
                            ) : (
                              <CheckBoxOutlineBlank />
                            )
                          }
                          onClick={() => {
                            setDetail(null);
                            props.getAllEmploymentContractByProfileId(parseInt(e.profileId));
                            handleChangeForm(
                              "profileIdForKpi",
                              values?.profileIdForKpi !== e.profileId ? parseInt(e.profileId) : null,
                            );
                          }}
                        >
                          Tính KPI
                        </Button>
                        {!values?.profileIdForKpi && <FormHelperText>Phải chọn 1 người tính KPI</FormHelperText>}
                      </FormControl>
                    </Grid>
                  )}
                  {values?.purposeId === 99999999 && (
                    <Grid item xs={2}>
                      <FormControl required fullWidth error={!values?.profileIdForReward}>
                        <Button
                          fullWidth
                          color="primary"
                          variant="outlined"
                          style={{ height: 40 }}
                          disabled={e.profileId === null}
                          startIcon={
                            typeof values?.profileIdForReward === "number" &&
                            values?.profileIdForReward === e.profileId ? (
                              <CheckBox />
                            ) : (
                              <CheckBoxOutlineBlank />
                            )
                          }
                          onClick={() => {
                            setDetail(null);
                            handleChangeForm(
                              "profileIdForReward",
                              values?.profileIdForReward !== e.profileId ? parseInt(e.profileId) : null,
                            );
                          }}
                        >
                          Tính thưởng
                        </Button>
                        {!values?.profileIdForReward && <FormHelperText>Phải chọn 1 người tính thưởng</FormHelperText>}
                      </FormControl>
                    </Grid>
                  )} */}
                  <Grid item xs={2}>
                    <FormControl fullWidth variant="outlined" size="small">
                      <InputLabel id="statusInProject-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                        Trạng thái
                      </InputLabel>
                      <Select
                        native
                        fullWidth
                        labelId="statusInProject-label"
                        value={e?.statusInProject || "K"}
                        onChange={(event) => handleChangeProfileList(index, "statusInProject", event.target.value)}
                      >
                        <option value="NCS">Đang làm NCS</option>
                        <option value="CH">Đang học Cao học</option>
                        <option value="K">Khác</option>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={1}>
                    <Button
                      fullWidth
                      color="secondary"
                      variant="contained"
                      style={{ height: 40 }}
                      onClick={() => handleRemove(index)}
                    >
                      Xoá
                    </Button>
                  </Grid>
                </Grid>
              ))}
            </Grid>

            <Grid item xs={12}>
              <Button fullWidth variant="outlined" onClick={handleInsert}>
                Thêm thành viên
              </Button>
            </Grid>

            <Grid item xs={5} style={{ margin: "auto" }}>
              <Divider />{" "}
            </Grid>
            <Grid item xs={2}>
              <Typography style={{ textAlign: "center", color: "rgba(0, 0, 0, 0.30)" }}>Sinh viên</Typography>
            </Grid>
            <Grid item xs={5} style={{ margin: "auto" }}>
              <Divider />{" "}
            </Grid>

            <Grid item xs={12}>
              {studentList.map((e, index) => (
                <Grid key={`student-${index}`} container spacing={2} style={{ marginBottom: 8 }}>
                  <Grid item xs={5}>
                    <TextField
                      required
                      fullWidth
                      size="small"
                      variant="outlined"
                      label="Tên sinh viên"
                      value={e?.studentName || ""}
                      error={studentHelperText && e.studentName === ""}
                      onChange={(event) => handleChangeStudentList(index, "studentName", event.target.value)}
                    />
                    {studentHelperText && e.studentName === "" && (
                      <FormHelperText style={{ color: "red" }}>Không được để trống</FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      required
                      fullWidth
                      size="small"
                      variant="outlined"
                      label="Mã sinh viên"
                      value={e?.studentCode || ""}
                      error={studentHelperText && e.studentCode === ""}
                      onChange={(event) => handleChangeStudentList(index, "studentCode", event.target.value)}
                    />
                    {studentHelperText && e.studentCode === "" && (
                      <FormHelperText style={{ color: "red" }}>Không được để trống</FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={3}>
                    <FormControl
                      required
                      fullWidth
                      variant="outlined"
                      size="small"
                      error={studentHelperText && !e?.roleInProject}
                    >
                      <InputLabel
                        id={`student-roleInProject-label-${index}`}
                        style={{ padding: "0 8px", backgroundColor: "white" }}
                      >
                        Vai trò
                      </InputLabel>
                      <Select
                        native
                        fullWidth
                        labelId={`student-roleInProject-label-${index}`}
                        value={e?.roleInProject || "member"}
                        onChange={(event) => handleChangeStudentList(index, "roleInProject", event.target.value)}
                      >
                        <option value="main">Chủ nhiệm</option>
                        <option value="member">Thành viên</option>
                      </Select>
                    </FormControl>
                    {studentHelperText && !e?.roleInProject && (
                      <FormHelperText style={{ color: "red" }}>Không được để trống</FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={1}>
                    <Button
                      fullWidth
                      color="secondary"
                      variant="contained"
                      style={{ height: 40 }}
                      onClick={() => handleRemoveStudent(index)}
                    >
                      Xóa
                    </Button>
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      label="Lớp"
                      value={e?.class || ""}
                      onChange={(event) => handleChangeStudentList(index, "class", event.target.value)}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      label="Ngành học"
                      value={e?.major || ""}
                      onChange={(event) => handleChangeStudentList(index, "major", event.target.value)}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      label="Khóa"
                      value={e?.cohort || ""}
                      onChange={(event) => handleChangeStudentList(index, "cohort", event.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      label="Số CMND/CCCD"
                      value={e?.identity || ""}
                      onChange={(event) => handleChangeStudentList(index, "identity", event.target.value)}
                    />
                  </Grid>
                </Grid>
              ))}
            </Grid>

            <Grid item xs={12}>
              <Button fullWidth variant="outlined" onClick={handleInsertStudent}>
                Thêm sinh viên
              </Button>
            </Grid>
          </Grid>
        </div>
        <div
          style={{
            flexDirection: "column",
            display: values?.profileIdForKpi !== null && values?.profileIdForKpi >= 0 ? "block" : "none",
          }}
        >
          <EmploymentContractTable
            contract={detail}
            setDetail={setDetail}
            contractList={contractList}
            kpiIdForKpi={values?.kpiIdForKpi}
            contractIdForKpi={values?.contractIdForKpi}
            handleChangeForm={handleChangeForm}
            values={values}
            setValues={setValues}
          />
          <EmploymentContractDetailTable kpi={detail} />
        </div>
        <div
          style={{
            width: "40%",
            padding: "16px 24px",
            overflowY: "auto",
            backgroundColor: "#fafafa",
          }}
        >
          <Typography variant="h6" style={{ marginBottom: 8 }}>
            File minh chứng
          </Typography>
          <div
            style={{
              backgroundColor: "#ffebee",
              color: "#c62828",
              padding: "12px",
              marginBottom: 12,
              borderRadius: 4,
              whiteSpace: "pre-line",
            }}
          >
            {`Upload file Scan bản gốc , bao gồm:
1. Quyết định giao
2. Thuyết minh/Hợp đồng
3. Quyết định nghiệm thu
4. Biên bản nghiệm thu`}
          </div>
          <MultiFileManager
            fileUrls={[]}
            setFileUrls={() => {}}
            newFiles={newFiles}
            setNewFiles={setNewFiles}
            disabled={false}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}

const mapStateToProps = (state) => ({
  role: select(state, "userReducer", "role"),
  profile: select(state, "profileReducer", "detail"),
  profileList: select(state, "profileReducer", "list"),
  purposes: select(state, "scientificResearchReducer", "purposes"),
  employmentContractListById: select(state, "employmentContractReducer", "listById"),
  timeResearchInformationList: select(state, "timeResearchInformationReducer", "list"),
  isFetchingTimeResearchInformation: select(state, "timeResearchInformationReducer", "isFetching"),
  // ----------- //
  scientificResearchs: select(state, "projectReducer", "scientificResearchs"),
  solutions: select(state, "projectReducer", "solutions"),
  patents: select(state, "projectReducer", "patents"),
  productContracts: select(state, "projectReducer", "productContracts"),
});

const mapDispatchToProps = (dispatch) => ({
  uploadMultiFile: (id, files, type) => dispatch(uploadMultiFile(id, files, type)),
  statisticUnaccepted: (payload) => dispatch(statisticUnaccepted(payload)),
  insertProject: (profileId, payload) => dispatch(insertProject(profileId, payload)),
  updateProject: (profileId, payload) => dispatch(updateProject(profileId, payload)),
  getAllEmploymentContractByProfileId: (id) => dispatch(getAllEmploymentContractByProfileId(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(ProjectInsertModal));

